import { useLocation, useOutlet } from "react-router-dom";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { Rail } from "./Rail";
import { BarreMobile } from "./BarreMobile";
import { MicroButton } from "./MicroButton";
import { ActionsProvider } from "@/context/ActionsContext";
import { PanneauAssistant } from "@/components/assistant/PanneauAssistant";
import { ApercuBandeau } from "@/components/theme/ApercuBandeau";
import { useMessagerie } from "@/context/ThemeContext";
import { ShellMessagerie } from "./ShellMessagerie";

export default function AppShell() {
  const messagerie = useMessagerie();
  return messagerie ? <ActionsProvider><ShellMessagerie /></ActionsProvider> : <ShellStandard />;
}

function ShellStandard() {
  const location = useLocation();
  const outlet = useOutlet();
  const reduire = useReducedMotion();
  const cle = location.pathname.split("/").slice(0, 2).join("/");
  return (
    <ActionsProvider>
    <div className="min-h-screen">
      <Rail />
      <div className="at-shell-contenu">
        <div className="sticky top-0 z-30"><ApercuBandeau /></div>
        <main className="px-6 md:px-[5.8vw] pt-3 md:pt-[2.9vw] pb-28 md:pb-28 max-w-[1700px] mx-auto">
          <AnimatePresence mode="wait" initial={false}>
            <motion.div key={cle}
              initial={{ opacity: 0, y: reduire ? 0 : 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: reduire ? 0 : -6 }}
              transition={{ duration: reduire ? 0 : 0.3, ease: [0.23, 1, 0.32, 1] }}>
              {outlet}
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
      <div className="hidden md:block fixed right-6 bottom-6 z-40 at-halo" data-testid="assistant-fab"><MicroButton fab testId="assistant-fab-button" /></div>
      <BarreMobile />
      <PanneauAssistant />
    </div>
    </ActionsProvider>
  );
}
